import TurndownService from 'turndown';
const turndownService = new TurndownService();
export const getHtmlToMd = function (Eleid = '', title = '', callback = () => {}, fail = () => {}) {
    try {
        let htmlEle = document.getElementById(Eleid);
        if (!Eleid || !htmlEle) throw Error('Eleid无效');
        let targetMd = turndownService.turndown(htmlEle.innerHTML);
        if (!title.trim()) title = '我的简历_' + Date.now();
        // console.log('getHtmlToMd md:', targetMd);
        const blob = new Blob([ targetMd ], { type: 'text/markdown' })
        const objectURL = URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = objectURL
        anchor.download = title + ".md";
        anchor.click()
        URL.revokeObjectURL(objectURL)
        callback && callback();
    } catch (error) {
        console.log('getHtmlToMd catch err:', error);
        fail && fail(error);
    }
}